export default "/images/14.png?306c8e421643dea96417e93c9abca56a";